import { createRouter, createWebHistory } from 'vue-router'

import { i18n } from '@/i18n'
import { routeNames } from '@/router/routeNames'
import { useUserStore } from '@/stores/userStore'

import { routes } from './routes'

const router = createRouter({
  history: createWebHistory(import.meta.env.BASE_URL),
  routes: routes,
})

router.beforeEach(async to => {
  const userStore = useUserStore()

  if (to.meta.auth && !userStore.isLoggedIn) {
    return { name: routeNames.Login }
  }

  if (to.name === routeNames.Login && userStore.isLoggedIn) {
    return {
      name: routeNames.Dashboard,
    }
  }
})

router.afterEach(to => {
  const titleKey = to.meta.title as string | undefined
  const appTitle = i18n.global.t('app.title')

  document.title = titleKey
    ? `${i18n.global.t(titleKey)} - ${appTitle}`
    : appTitle
})

export default router
